module.exports = __webpack_public_path__ + "img/albania.673a2c7b.svg";